<template>
    <div class="extension-dashboard-card-header">
        <div>
            <VcPopover
                trigger="hover"
                placement="top"
            >
                <template #reference>
                    <div
                        :style="nameStyles"
                        class="user-name"
                    >
                        {{ userName }}
                    </div>
                </template>
                <div class="p-2">
                    {{ userName }}
                </div>
            </VcPopover>
        </div>
        <div class="flex gap-2 justify-end">
            <span class="total-call">
                {{ t('statistics.total.calls.duration') }}
            </span>
            <RedesignTag
                :background-color="'#fff'"
                :tag-content="tagContent"
                bold
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { VcPopover } from '@voicenter-team/voicenter-ui-plus'
import RedesignTag from '@/components/RedesignBaseComponents/RedesignTag.vue'
import { ITagContent } from '@/types/tag'

const { t } = useI18n()

interface ITextStyling {
    fontSize: string
    lineHeight: string
}

const props = defineProps<{
    userName: string,
    tagContent: ITagContent[]
    nameStyles: ITextStyling
}>()

</script>

<style scoped lang="scss">
.extension-dashboard-card-header {
    @apply
    grid
    grid-cols-2
    gap-x-2
    bg-gray-100
    items-center
    py-2
    px-4;

  .total-call {
    @apply text-xs font-medium text-gray-500;
    line-height: 27.94px;
    font-variant: all-small-caps;
  }
  .user-name {
    @apply font-medium;
    text-wrap: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

</style>
